/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    Paper,
    CardContent,
    Typography,
    Box,
    Fade,
    FormControlLabel,
    Checkbox,
    Button
} from '@mui/material';
import {
    LocationOn,
    Add,
    LocationCity,
    Public,
    Edit as EditIcon,
    Save as SaveIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';
import { useSite } from 'hooks/api/terminology/site/useSite';
import { AnimatedButton, StyledCard, StyledTextField, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';

const AddEditSite = ({ editingSite, onSiteSubmitted, districts, provinces }) => {
    const [formData, setFormData] = useState({
        name: '',
        id: '',
        localName: '',
        siteType: 'SITE',
        description: '',
        isActive: true,
        address: '',
        postalCode: '',
        district: {
            id: '',
            province: {
                id: ''
            }
        }
    });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const { createSite, updateSite } = useSite();

    // Initialize form data when editing
    useEffect(() => {
        if (editingSite) {
            setFormData({
                name: editingSite.name || '',
                id: editingSite.id || '',
                localName: editingSite.localName || '',
                siteType: editingSite.siteType || 'SITE',
                description: editingSite.description || '',
                isActive: editingSite.isActive !== undefined ? editingSite.isActive : true,
                address: editingSite.address || '',
                postalCode: editingSite.postalCode || '',
                district: {
                    id: editingSite.district?.id || '',
                    province: {
                        id: editingSite.district?.province?.id || ''
                    }
                }
            });
        } else {
            // Reset form for new site
            setFormData({
                name: '',
                id: '',
                localName: '',
                siteType: 'SITE',
                description: '',
                isActive: true,
                address: '',
                postalCode: '',
                district: {
                    id: '',
                    province: {
                        id: ''
                    }
                }
            });
        }
        setErrors({});
    }, [editingSite]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = 'Site name is required';
        }
        
        if (!formData.id.trim()) {
            newErrors.id = 'Site code is required';
        }
        
        if (!formData.district.province.id) {
            newErrors.province = 'Province is required';
        }
        
        if (!formData.district.id) {
            newErrors.district = 'District is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData((prev) => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }

        // Clear error when user starts typing
        if (errors[name] || errors[name?.split('.')[1]]) {
            setErrors(prev => ({
                ...prev,
                [name]: '',
                [name?.split('.')[1]]: ''
            }));
        }
    };

    const handleProvinceChange = (event) => {
        const provinceId = event.target.value;
        setFormData((prev) => ({
            ...prev,
            district: {
                id: '', // Reset district when province changes
                province: {
                    id: provinceId
                }
            }
        }));
        
        // Clear district error when province changes
        if (errors.district) {
            setErrors(prev => ({ ...prev, district: '' }));
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fill in all required fields correctly.'
            });
            return;
        }

        setLoading(true);
        try {
            if (editingSite) {
                await updateSite(editingSite.id, formData);
                Swal.fire({
                    icon: 'success',
                    title: 'Site Updated',
                    text: 'The site has been successfully updated.',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                await createSite(formData);
                Swal.fire({
                    icon: 'success',
                    title: 'Site Created',
                    text: 'The site has been successfully created.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            onSiteSubmitted();
        } catch (error) {
            logger.error('Error saving site:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Failed to ${editingSite ? 'update' : 'create'} the site. Please try again.`
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        onSiteSubmitted();
    };

    const getFilteredDistricts = () => {
        return districts.filter(district => 
            district.province?.id === formData.district.province.id
        );
    };

    return (
        <Fade in timeout={1000}>
            <StyledCard elevation={0}>
                <CardContent>
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            color: globalColor,
                            fontWeight: 'bold',
                            mb: 4
                        }}
                    >
                        <LocationOn /> {editingSite ? 'Edit Site' : 'Add New Site'}
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="name"
                                label="Site Name *"
                                value={formData.name}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.name}
                                helperText={errors.name}
                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="id"
                                label="Site Code *"
                                value={formData.id}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.id}
                                helperText={errors.id}
                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                select
                                fullWidth
                                name="district.province.id"
                                label="Province *"
                                value={formData.district.province.id}
                                onChange={handleProvinceChange}
                                variant="outlined"
                                error={!!errors.province}
                                helperText={errors.province}
                                disabled={loading}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ mr: 1, color: globalColor }}>
                                            <Public fontSize="small" />
                                        </Box>
                                    )
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select Province</em>
                                </MenuItem>
                                {provinces.map((province) => (
                                    <MenuItem key={province.id} value={province.id}>
                                        {province.name}
                                    </MenuItem>
                                ))}
                            </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                select
                                fullWidth
                                name="district.id"
                                label="District *"
                                value={formData.district.id}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.district}
                                helperText={errors.district}
                                disabled={loading || !formData.district.province.id}
                                InputProps={{
                                    startAdornment: (
                                        <Box sx={{ mr: 1, color: globalColor }}>
                                            <LocationCity fontSize="small" />
                                        </Box>
                                    )
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select District</em>
                                </MenuItem>
                                {getFilteredDistricts().map((district) => (
                                    <MenuItem key={district.id} value={district.id}>
                                        {district.name}
                                    </MenuItem>
                                ))}
                            </StyledTextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="address"
                                label="Address"
                                value={formData.address}
                                onChange={handleChange}
                                variant="outlined"
                                multiline
                                rows={2}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="postalCode"
                                label="Postal Code"
                                value={formData.postalCode}
                                onChange={handleChange}
                                variant="outlined"
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <StyledTextField
                                fullWidth
                                name="description"
                                label="Description"
                                value={formData.description}
                                onChange={handleChange}
                                variant="outlined"
                                multiline
                                rows={3}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                        name="isActive"
                                        disabled={loading}
                                        sx={{
                                            color: globalColor,
                                            '&.Mui-checked': {
                                                color: globalColor
                                            }
                                        }}
                                    />
                                }
                                label="Active"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                    sx={{
                                        borderColor: globalColor,
                                        color: globalColor,
                                        '&:hover': {
                                            borderColor: globalColor,
                                            backgroundColor: `${globalColor}10`
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <AnimatedButton
                                    variant="contained"
                                    startIcon={editingSite ? <SaveIcon /> : <Add />}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    size="large"
                                >
                                    {loading ? 'Saving...' : (editingSite ? 'Update Site' : 'Add Site')}
                                </AnimatedButton>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
        </Fade>
    );
};

export default AddEditSite;